/**
 * Teclado físico para marcadores (FAB + página Marcador).
 */

/** `true` si el foco no debe disparar dígitos globales (campo número, otros inputs, etc.). */
export function isForeignTextInputForDialer(target: EventTarget | null): boolean {
  const el = target as HTMLElement | null;
  if (!el) return false;
  if (el.closest('[data-sf-dialer-number-field]')) return true;
  if (el.isContentEditable) return true;
  const tag = el.tagName;
  if (tag === 'TEXTAREA' || tag === 'SELECT' || tag === 'INPUT') return true;
  return false;
}

/**
 * Mapea una tecla a dígito de marcador, o `null`.
 * Soporta fila numérica, * y #, teclado numérico (Numpad0–9, Multiply).
 */
export function mapKeyboardEventToDialDigit(e: Pick<KeyboardEvent, 'key' | 'code'>): string | null {
  const { key, code } = e;
  if (key.length === 1 && key >= '0' && key <= '9') return key;
  if (key === '*' || key === '#') return key;

  const numpadDigit = /^Numpad([0-9])$/.exec(code);
  if (numpadDigit) return numpadDigit[1];
  if (code === 'NumpadMultiply') return '*';

  return null;
}
